export const CSRF_RELOAD_TIMEOUT = 3000;
export const DESKTOP_WIDTH = 1024;
export const CART_ICON_ANIMATION_DURATION = 500;
export const OPEN_CART_FOR_DESKTOP_BUFFER = 100;
export const AUTO_CLOSE_CART_FOR_DESKTOP_DELAY = 2000;
export const OPEN_CART_FOR_DESKTOP_DELAY =
  CART_ICON_ANIMATION_DURATION + OPEN_CART_FOR_DESKTOP_BUFFER;

// Line item discount types
export const DISCOUNT_TYPES = {
  COMMITMENT: '@juul/discount_types/commitment_discount',
  MEMBERSHIP: '@juul/discount_types/membership_discount',
  PROMO_CODE: '@juul/discount_types/promo_code_discount',
  SALE_PRICE: '@juul/discount_types/sale_price_discount',
};
export const DISCOUNTS_DISPLAYED_IN_LINE_ITEM = [
  DISCOUNT_TYPES.COMMITMENT,
  DISCOUNT_TYPES.MEMBERSHIP,
  DISCOUNT_TYPES.SALE_PRICE,
];
export const DISCOUNTS_DISPLAYED_IN_SUBTOTAL = [DISCOUNT_TYPES.PROMO_CODE];

// Segment Analytics Events
export const AUTO_SHIP_ENABLED = 'Auto-Ship Enabled';
export const AUTO_SHIP_DISABLED = 'Auto-Ship Disabled';
export const PRODUCT_ADDED = 'Product Added';
export const PRODUCT_REMOVED = 'Product Removed';
export const CART_UPSELL_BANNER = 'Cart Upsell Banner';
export const QUICK_SHOP_INTERACTION = 'Quick Shop Interaction';
export const OPEN_QUICK_SHOP_MODAL = 'Open Quick Shop Modal';
export const CLOSE_QUICK_SHOP_MODAL = 'Close Quick Shop Modal';
export const NICOTINE_STRENGTH = 'Nicotine Strength';
export const POD_PACK_SIZE = 'Pod Pack Size';
export const CONVERT_TO_SUBSCRIPTION_CLICKED =
  'Convert to Subscription Clicked';
export const ONE_TIME_OPTION_SELECTED = 'One-time Option Selected';
export const SUBSCRIBE_OPTION_SELECTED = 'Subscribe Option Selected';
export const ADD_TO_CART_AND_SUBSCRIBE_CLICKED =
  'Add to Cart and Subscribe Clicked';
